module.exports = __webpack_public_path__ + "static/img/QR-public.12e304c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QR-public.png
// module id = fdcc
// module chunks = 18